import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { Platform } from '@cart-services/hooks/fp-b2b/store-map'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { Redirect, Route, Switch } from 'react-router-dom-v5'
import { AppBarProvider } from '../../../components/AppBar/AppBarProvider'
import { ThankyouProvider } from '../../fp-b2b-shared/components/ThankyouProvider/ThankyouProvider'
import { AuthProcessing } from '../AuthProcessing'
import { MerchantLogin } from '../MerchantLogin/MerchantLogin'
import { RefreshCosignToken } from '../MerchantLogin/RefreshCosignToken'
import { MerchantThankyou } from '../thankyou/MerchantThankyou'

export const UnauthRoutes = () => {
  const { campaignCodeFromUrl } = useCampaignCode()
  const { destructuredData: campaign } = useApiCampaignActivityInfo(campaignCodeFromUrl)
  const projectCode = campaign?.brand_codes_info[0]?.project_code
  const campaignId = campaign?.campaign_id
  const countryCode = campaign?.region
  return (
    <Switch>
      <Route path="/merchant/:code/login" exact>
        <RefreshCosignToken />
        <MerchantLogin />
      </Route>
      <Route path="/merchant/:code/auth-processing" exact>
        <AuthProcessing />
      </Route>
      <Route path="/merchant/:code/thankyou/:orderHash">
        <AppBarProvider environment="merchant">
          {projectCode && countryCode && campaignId
          && (
            <ThankyouProvider
              projectCode={projectCode}
              countryCode={countryCode}
              currency={campaign?.currency}
              campaignId={campaignId}
              platform={Platform.MERCHANT}
            >
              <MerchantThankyou />
            </ThankyouProvider>
          )}
        </AppBarProvider>
      </Route>
      <Route path="*">
        <Redirect to={`/merchant/${campaignCodeFromUrl}/login`} />
      </Route>
    </Switch>
  )
}
